import { accessEventsConstants } from "../_constants";
import { accessEventsServices } from "../_services";

export const accessEventsActions = {
  applyFilters,
  getAllEventStatus,
  getAllFilters,
  getAllSecurityAudits,
  getSecurityAuditTopCardInfo,
};

function getAllFilters() {
  return (dispatch) => {
    dispatch(request());
    accessEventsServices.getAllFilters().then(
      (filtersAudit) => dispatch(success(filtersAudit)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: accessEventsConstants.GET_EVENT_ACCESS_FILTERS_REQUEST };
  }
  function success(filtersAudit) {
    return {
      type: accessEventsConstants.GET_EVENT_ACCESS_FILTERS_SUCCESS,
      filtersAudit,
    };
  }
  function failure(error) {
    return {
      type: accessEventsConstants.GET_EVENT_ACCESS_FILTERS_FAILURE,
      error,
    };
  }
}

function getAllEventStatus() {
  return (dispatch) => {
    dispatch(request());
    accessEventsServices.getAllEventStatus().then(
      (events) => dispatch(success(events)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: accessEventsConstants.GET_EVENT_ACCESS_STATUS_REQUEST };
  }
  function success(events) {
    return {
      type: accessEventsConstants.GET_EVENT_ACCESS_STATUS_SUCCESS,
      events,
    };
  }
  function failure(error) {
    return {
      type: accessEventsConstants.GET_EVENT_ACCESS_STATUS_FAILURE,
      error,
    };
  }
}

function getAllSecurityAudits(offset, limit) {
  return (dispatch) => {
    dispatch(request());
    accessEventsServices.getAllSecurityAudits(offset, limit).then(
      (accessEvents) => dispatch(success(accessEvents)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: accessEventsConstants.GETALL_ACCESS_EVENTS_REQUEST };
  }
  function success(accessEvents) {
    return {
      type: accessEventsConstants.GETALL_ACCESS_EVENTS_SUCCESS,
      accessEvents,
    };
  }
  function failure(error) {
    return { type: accessEventsConstants.GETALL_ACCESS_EVENTS_FAILURE, error };
  }
}

function getSecurityAuditTopCardInfo() {
  return (dispatch) => {
    dispatch(request());
    accessEventsServices.getSecurityAuditTopCardInfo().then(
      (accessEventsTopCards) => dispatch(success(accessEventsTopCards)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: accessEventsConstants.GET_ACCESS_EVENTS_TOP_CARDS_REQUEST };
  }
  function success(accessEventsTopCards) {
    return {
      type: accessEventsConstants.GET_ACCESS_EVENTS_TOP_CARDS_SUCCESS,
      accessEventsTopCards,
    };
  }
  function failure(error) {
    return {
      type: accessEventsConstants.GET_ACCESS_EVENTS_TOP_CARDS_FAILURE,
      error,
    };
  }
}

// usecaseName, type, user, status, startDate, endDate, search, offset, limit
function applyFilters(user, status, startDate, endDate, search, offset, limit) {
  return (dispatch) => {
    dispatch(request());
    accessEventsServices
      .applyFilters(user, status, startDate, endDate, search, offset, limit)
      .then(
        (audits) => dispatch(success(audits)),
        (error) => dispatch(failure(error.toString()))
      );
  };

  function request() {
    return { type: accessEventsConstants.GETALL_ACCESS_EVENTS_REQUEST };
  }
  function success(accessEvents) {
    return {
      type: accessEventsConstants.GETALL_ACCESS_EVENTS_SUCCESS,
      accessEvents,
    };
  }
  function failure(error) {
    return { type: accessEventsConstants.GETALL_ACCESS_EVENTS_FAILURE, error };
  }
}
